import { render, staticRenderFns } from "./ProgramDocuments.vue?vue&type=template&id=db781d96&"
import script from "./ProgramDocuments.vue?vue&type=script&lang=js&"
export * from "./ProgramDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ProgramDocuments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports